import { useTranslation } from "react-i18next";

export const columnsToShowVehicleExpected = [
  {
    pretty_name: 'Vehicle No.',
    column_id: 'vehicle_number',
  },
  {
    pretty_name: 'MM Trip No.',
    column_id: 'ist_reference_number',
  },
  {
    pretty_name: 'Route Code',
    column_id: 'route_code',
  },
  {
    pretty_name: 'Connection Time',
    column_id: 'connection_time',
  },
  {
    pretty_name: 'Scheduled Arrival Time',
    column_id: 'scheduled_arrival_time',
  },
  {
    pretty_name: 'Current Vacancy (%)',
    column_id: 'current_vacancy',
  },
  {
    pretty_name: 'Post Unload Vacancy (%)',
    column_id: 'post_unload_vacancy',
  },
  {
    pretty_name: 'Origin',
    column_id: 'origin_hub_code',
  },
  {
    pretty_name: 'Current Status',
    column_id: 'status',
  },
  {
    pretty_name: '#Waybills to Unload',
    column_id: 'way_bill_count',
  },
  {
    pretty_name: 'Last Updated Time',
    column_id: 'last_status_change_time',
  },
  {
    pretty_name: 'FLM Trip No.',
    column_id: 'trip_reference_number',
  },
  {
    pretty_name: 'Transfer Weight(in Kgs)',
    column_id: 'transfer_weight',
  },
  {
    pretty_name: 'Carrier',
    column_id: 'courier_partner',
  },
  {
    pretty_name: 'Carrier Manifest No.',
    column_id: 'courier_partner_reference_number',
  },
  {
    pretty_name: 'SAP Trip Number',
    column_id: 'ril_trip_number',
  },
];
export const midMileColumnsToShow = [
  {
    pretty_name: 'Carrier',
    column_id: 'courier_partner',
  },
  {
    pretty_name: 'Transportation Mode',
    column_id: 'transportation_mode',
  },
  {
    pretty_name: 'Is Handed Over 3PL',
    column_id: 'is_handed_over_to_3pl',
  },
  {
    pretty_name: 'Flight Number',
    column_id: 'flight_number',
  },
  {
    pretty_name: 'Flight Date',
    column_id: 'flight_date',
  },
  {
    pretty_name: 'Flight Time',
    column_id: 'flight_time',
  },
  {
    pretty_name: 'Transfer Weight(in Kgs)',
    column_id: 'transfer_weight',
  },
  {
    pretty_name: 'Carrier',
    column_id: 'courier_partner',
  },
  {
    pretty_name: 'Carrier Manifest No.',
    column_id: 'courier_partner_reference_number',
  },
];
export const columnsToShowVehicleAttendanceView = [
  {
    pretty_name: 'Vehicle No.',
    column_id: 'vehicle_number',
  },
  {
    pretty_name: 'Fleet Type',
    column_id: 'fleet_type',
  },
];
export const columnsToShowVehicleView = [
  {
    pretty_name: 'Vehicle No.',
    column_id: 'vehicle_number',
  },
  {
    pretty_name: 'MM Trip No.',
    column_id: 'ist_reference_number',
  },
  {
    pretty_name: 'Route Code',
    column_id: 'route_code',
  },
  {
    pretty_name: 'Connection Time',
    column_id: 'connection_time',
  },
  {
    pretty_name: 'Origin',
    column_id: 'origin_hub_code',
  },
  {
    pretty_name: 'Dock No.',
    column_id: 'current_dock_code',
  },
  {
    pretty_name: 'Gate No.',
    column_id: 'current_gate_name',
  },
  {
    pretty_name: 'Current Status',
    column_id: 'status',
  },
  {
    pretty_name: '#Waybills',
    column_id: 'way_bill_count',
  }, {
    pretty_name: 'Last Updated Time',
    column_id: 'last_status_change_time',
  },
  {
    pretty_name: 'FLM Trip No.',
    column_id: 'trip_reference_number',
  },
  {
    pretty_name: 'Transfer Weight(in Kgs)',
    column_id: 'transfer_weight',
  },
  {
    pretty_name: 'Carrier',
    column_id: 'courier_partner',
  },
  {
    pretty_name: 'Carrier Manifest No.',
    column_id: 'courier_partner_reference_number',
  },
  {
    pretty_name: 'SAP Trip Number',
    column_id: 'ril_trip_number',
  },
];
export const columnsToShowVehicleOutbound = [
  {
    pretty_name: 'Vehicle No.',
    column_id: 'vehicle_number',
  },
  {
    pretty_name: 'MM Trip No.',
    column_id: 'ist_reference_number',
  },
  {
    pretty_name: 'Route Code',
    column_id: 'route_code',
  },
  {
    pretty_name: 'Connection Time',
    column_id: 'connection_time',
  },
  {
    pretty_name: 'Origin',
    column_id: 'origin_hub_code',
  },
  {
    pretty_name: 'Dock No.',
    column_id: 'current_dock_code',
  },
  {
    pretty_name: 'Gate No.',
    column_id: 'current_gate_name',
  },
  {
    pretty_name: 'Current Status',
    column_id: 'status',
  },
  {
    pretty_name: '#Waybills',
    column_id: 'way_bill_count',
  },
  {
    pretty_name: 'Capacity Utilized (%)',
    column_id: 'capacity_utilized',
  },
  {
    pretty_name: 'Last Updated Time',
    column_id: 'last_status_change_time',
  },
  {
   pretty_name: 'Ewaybill Status',
   column_id: 'ewb_status',
  },
  {
    pretty_name: 'FLM Trip No.',
    column_id: 'trip_reference_number',
  },
  {
    pretty_name: 'Transfer Weight(in Kgs)',
    column_id: 'transfer_weight',
  },
  {
    pretty_name: 'Carrier',
    column_id: 'courier_partner',
  },
  {
    pretty_name: 'Carrier Manifest No.',
    column_id: 'courier_partner_reference_number',
  },
  {
    pretty_name: 'SAP Trip Number',
    column_id: 'ril_trip_number',
  },
];

export const columnsToShowISTCreated = [
  {
    pretty_name: 'Vehicle No.',
    column_id: 'vehicle_number',
  },
  {
    pretty_name: 'Trip No.',
    column_id: 'ist_reference_number',
  },
  {
    pretty_name: 'Route Code',
    column_id: 'route_code',
  },
  {
    pretty_name: 'Connection Time',
    column_id: 'connection_time',
  },
  {
    pretty_name: 'Dock No.',
    column_id: 'current_dock_code',
  },
  {
    pretty_name: 'Gate No.',
    column_id: 'current_gate_name',
  },
  {
    pretty_name: 'Current Status',
    column_id: 'status',
  },
  {
    pretty_name: '#Waybills',
    column_id: 'way_bill_count',
  },
  {
    pretty_name: 'Last Updated Time',
    column_id: 'last_status_change_time',
  },
  {
    pretty_name: 'Driver',
    column_id: 'driver_name',
  },
  {
    pretty_name: 'Driving License No.',
    column_id: 'driving_license_number',
  },
  {
    pretty_name: 'Vehicle Request Reference Number',
    column_id: 'vehicle_request_reference_number',
  },
  {
    pretty_name: 'Driving License Expiry',
    column_id: 'driving_license_expiry_date',
  },
  {
    pretty_name: 'SAP Trip Number',
    column_id: 'ril_trip_number',
  },
];

export const columnsToShowISTView = [
  {
    pretty_name: 'Vehicle No.',
    column_id: 'vehicle_number',
  },
  {
    pretty_name: 'Trip No.',
    column_id: 'ist_reference_number',
  },
  {
    pretty_name: 'Route Code',
    column_id: 'route_code',
  },
  {
    pretty_name: 'Connection Time',
    column_id: 'connection_time',
  },
  {
    pretty_name: 'Origin',
    column_id: 'origin_hub_code',
  },
  {
    pretty_name: 'Dock No.',
    column_id: 'current_dock_code',
  },
  {
    pretty_name: 'Gate No.',
    column_id: 'current_gate_name',
  },
  {
    pretty_name: 'Current Status',
    column_id: 'status',
  },
  {
    pretty_name: '#Waybills',
    column_id: 'way_bill_count',
  },
  {
    pretty_name: 'Last Updated Time',
    column_id: 'last_status_change_time',
  },
  {
    pretty_name: 'Vehicle Request Reference Number',
    column_id: 'vehicle_request_reference_number',
  },
  {
    pretty_name: 'Driver',
    column_id: 'driver_name',
  },
  {
    pretty_name: 'Driving License No.',
    column_id: 'driving_license_number',
  },
  {
    pretty_name: 'Driving License Expiry',
    column_id: 'driving_license_expiry_date',
  },
  {
    pretty_name: 'SAP Trip Number',
    column_id: 'ril_trip_number',
  },
  {
    pretty_name: 'Is Billed',
    column_id: 'is_billed',
  },
  {
    pretty_name: 'Is Verified',
    column_id: 'is_verified',
  },
];

export const getColumnsToShow = (bucket: any) => {
  switch (bucket) {
    case 'tms_vehicle_expected':
      return columnsToShowVehicleExpected;
    case 'tms_vehicle_arrived':
    case 'tms_vehicle_unloading':
    case 'tms_vehicle_loading':
      return columnsToShowVehicleView;
    case 'tms_vehicle_outbound':
      return columnsToShowVehicleOutbound;
    case 'tms_ist_created':
      return columnsToShowISTCreated.concat(midMileColumnsToShow);
    case 'tms_ist_arrived':
    case 'tms_ist_unloading':
    case 'tms_ist_departed':
    case 'tms_ist_completed':
      return columnsToShowISTView.concat(midMileColumnsToShow);
    case 'tms_ist_loaded':
    case 'tms_ist_loading':
      return columnsToShowISTView.concat([{
        pretty_name: 'Ewaybill Status',
        column_id: 'ewb_status',
      }]).concat(midMileColumnsToShow);
    default:
      return columnsToShowVehicleView.concat(midMileColumnsToShow);
  }

};
export const actionsByType = {
  inboundActions: [
    'gate_in', 'receive_ist', 'unloading', 'close_ist', 'hub_arrival',
  ],
  outboundActions: [
    'create_trip', 'depart_ist', 'loading', 'gate_out',
  ],
  dockActions: [
    'assign_dock', 'dock_inscan', 'dock_outscan',
  ],
  otherActions: [
    'apply_exception_code', 'offload', 'print_manifest', 'add_trip_penalties', 'delete_trip',
  ],
};
export const getStatusesPrettyNameMapping = {
  gatein: 'Gate In',
  gateout: 'Gate Out',
  dockassign: 'Dock Assign',
  dockinscan: 'Dock Inscan',
  loaded: 'Loaded',
  sealed: 'Sealed',
  departed: 'Departed',
  dockoutscan: 'Dock Outscan',
  inscan_at_hub: 'Inscan at Hub',
  softdata_upload: 'Softdata Upload',
  intransit_to_hub: 'In Transit',
  outscan_at_hub: 'Outscan',
  loading: 'Loading',
  created: 'Created',
  intransittohub: 'In Transit',
  all_consignment_received: 'All CNs Received',
  debagged: 'Debagged',
  added_to_ist: 'Added to IST',
  received_against_ist: 'Received Against IST',
  reached_at_hub: 'Reached At Hub',
  assigned_courier_partner:'Assigned carrier partner',
  handover_courier_partner: 'Handover carrier partner',
  pickup_awaited: 'Pickup Awaited',
  pickup_completed: 'Pickup Completed',
  pickup_scheduled: 'Pickup Scheduled',
  in_transit: 'In Transit',
  bag_received: 'Bag Received',
  on_hold: 'On Hold',
  exception: 'Exception',
  out_for_pickup: 'Out for Pickup',
  not_picked_up: 'Not Picked Up',
  cancelled: 'Cancelled',
  bagged: 'Bagged',
  shelved: 'Shelved',
  undelivered: 'Undelivered',
  outfordelivery: 'Out for Delivery',
  delivered: 'Delivered',
  deps_exception: 'DEPS',
};
export const actionType = ['inboundActions', 'outboundActions', 'dockActions', 'otherActions'];
export const tmsStatusesPrettyNames = (x) => {
  return getStatusesPrettyNameMapping[x] ? getStatusesPrettyNameMapping[x] : x;
};
export const columnsToShowISTDetails = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    pretty_name: 'Waybill#',
    column_id: 'reference_number',
  },
  { pretty_name: 'Weight (KG)', column_id: 'weight' },
  {
    pretty_name: 'Waybill Type',
    column_id: 'type',
  },
  {
    pretty_name: 'Destination',
    column_id: 'destination_hub',
  },
  {
    pretty_name: 'Status',
    column_id: 'status',
  },
  {
    pretty_name: 'Last Updated Time',
    column_id: 'updated_at',
  },
  {
    pretty_name: 'Customer Reference Number',
    column_id: 'customer_reference_number',
  }
];
export const columnsToShowISTDetailsTracking = [
  {
    pretty_name: 'Event Time',
    column_id: 'event_time',
  },
  {
    pretty_name: 'Location',
    column_id: 'hub_code',
  },
  {
    pretty_name: 'Updated By',
    column_id: 'updated_by',
  },
  {
    pretty_name: 'Event',
    column_id: 'event_string',
  },
  {
    pretty_name: 'Notes',
    column_id: 'additional_info',
  },
];
export const columnsToShowWaybillsScanning = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    pretty_name: 'Waybills',
    column_id: 'reference_number',
  },
  { pretty_name: 'Origin', column_id: 'origin_hub_code' },
  {
    pretty_name: 'Destination',
    column_id: 'destination_hub_code',
  },
  {
    pretty_name: 'No. of Consignments',
    column_id: 'consignment_count',
  },
  {
    pretty_name: 'Unloading Destination',
     column_id: 'route_destination_hub_code',
  },
  {
    pretty_name: 'Actions',
    column_id: 'actions',
  },
];
export const columnsToShowWaybillsUnloading = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    pretty_name: 'Waybills',
    column_id: 'reference_number',
  },
  { pretty_name: 'Origin', column_id: 'origin_hub_code' },
  {
    pretty_name: 'Destination',
    column_id: 'destination_hub_code',
  },
  {
    pretty_name: 'No. of Consignments',
    column_id: 'consignment_count',
  },
  {
    pretty_name: 'Loading Origin',
     column_id: 'loading_hub_code',
  },
  {
    pretty_name: 'Scanning Status',
    column_id: 'scanned_status',
  },
  {
    pretty_name: 'Actions',
    column_id: 'actions',
  },
];
export const columnsToShowBagDetails = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    pretty_name: 'CN#',
    column_id: 'reference_number',
  },
  {
    pretty_name: 'EWB No.',
    column_id: 'ewb_number',
  },
  {
    pretty_name: 'EWB Validity',
    column_id: 'eway_bill_expiry',
  },
  {
    pretty_name: 'Declared Value',
    column_id: 'declared_value',
  },
  {
    pretty_name: 'Weight (KG)',
    column_id: 'weight',
  },
  {
    pretty_name: 'Service Type',
    column_id: 'service_type',
  },
  {
    pretty_name: 'Current Hub',
    column_id: 'current_hub',
  },
  {
    pretty_name: 'Destination Pincode',
    column_id: 'destination_pincode',
  },
  {
    pretty_name: 'Status',
    column_id: 'status',
  },
  {
    pretty_name: 'Last Updated Time',
    column_id: 'updated_at',
  },
];

export const columnsToShowBagDetailsTracking = [
  {
    pretty_name: 'Time',
    column_id: 'event_time',
  },
  {
    pretty_name: 'Status',
    column_id: 'event_type',
  },
  {
    pretty_name: 'Location',
    column_id: 'location',
  },
  {
    pretty_name: 'Employee Code',
    column_id: 'employee_code',
  },
  {
    pretty_name: 'Event',
    column_id: 'event_string',
  },
  {
    pretty_name: 'Notes',
    column_id: 'notes',
  },
  {
    pretty_name: 'Carrier Status',
    column_id: 'status_courier_partner',
  },
  {
    pretty_name: 'Carrier Failure Reason',
    column_id: 'carrier_failure_reason',
  },
  {
    pretty_name: 'Shipsy Failure Reason',
    column_id: 'shipsy_failure_reason',
  },
];
export const actionNamesMapping = {
  hub_arrival: 'Hub Arrival',
  receive_ist : 'Trip Receive',
  depart_ist : 'Trip Depart',
  close_ist: 'Trip Close',
  gate_in: 'Gate In',
  unloading: 'Unloading',
  create_trip: 'Create Trip',
  loading: 'Loading',
  gate_out: 'Gate Out',
  assign_dock: 'Assign Dock',
  dock_inscan: 'Dock Inscan',
  dock_outscan: 'Dock Outscan',
  apply_exception_code: 'Apply Exception Code',
  offload: 'Offload',
  print_manifest: 'Print Manifest',
  add_trip_penalties: 'Add Trip Penalties',
  delete_trip: 'Delete Trip',
};

export const getActionsPrettyName = (x) => {
  return actionNamesMapping[x] || x;
};

export const ColumnsToShowInSetupRoutes = [
  {
    column_id: 'route_code',
    pretty_name: 'Route Code',
  },
  {
    column_id: 'origin_hub_code',
    pretty_name: 'Origin',
  },
  {
    column_id: 'destination_hub_code',
    pretty_name: 'Destination',
  },
  {
    column_id: 'num_nodes',
    pretty_name: '#Nodes',
  },
  {
    column_id: 'route_name',
    pretty_name: 'Route Name',
  },
  {
    column_id: 'master_last_updated_by',
    pretty_name: 'Last Updated By',
  },
  {
    column_id: 'master_last_updated_at',
    pretty_name: 'Last Updated At',
  },
  {
    column_id: 'created_by',
    pretty_name: 'Created By',
  },
  {
    column_id: 'created_at',
    pretty_name: 'Created At',
  },
  {
    column_id: 'vehicle_data',
    pretty_name: 'Vehicle Data',
  }
];
export const ExtendedColumnsToShowInSetupRoutes = [
  {
    column_id: 'trip_type',
    pretty_name: 'Trip Type',
  },
];
export const columnsToShowRouteDetails = [
  {
    column_id: 'hub_code',
    pretty_name: 'Hub Code',
  },
  {
    column_id: 'hub_name',
    pretty_name: 'Hub Name',
  },
  {
    column_id: 'distance_from_previous_hub',
    pretty_name: 'Distance (in KM)',
  },
  {
    column_id: 'transit_time',
    pretty_name: 'Transit Time (HH:MM)',
  },
  {
    column_id: 'stoppage_time',
    pretty_name: 'Stoppage Time (HH:MM)',
  },
  {
    column_id: 'distance_variance',
    pretty_name: 'Variance in %',
  },
];
export const ColumnsToShowInSetupConnections = [
  {
    column_id: 'route_code',
    pretty_name: 'Route Code',
  },
  {
    column_id: 'connection_code',
    pretty_name: 'Connection Code',
  },
  {
    column_id: 'hub_code',
    pretty_name: 'Hub',
  },
  {
    column_id: 'is_active',
    pretty_name: 'Active',
  },
  {
    column_id: 'arrival_time',
    pretty_name: 'Arrival Time',
  },
  {
    column_id: 'departure_time',
    pretty_name: 'Departure Time',
  },
  {
    column_id: 'master_last_updated_by',
    pretty_name: 'Last Updated By',
  },
  {
    column_id: 'master_last_updated_at',
    pretty_name: 'Last Updated At',
  },
  {
    column_id: 'created_by',
    pretty_name: 'Created By',
  },
  {
    column_id: 'created_at',
    pretty_name: 'Created At',
  },
];
export const columnsToShowOffload = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'reference_number',
    pretty_name: 'Waybills',
  },
  {
    column_id: 'origin_hub_code',
    pretty_name: 'Origin',
  },
  {
    column_id: 'destination_hub_code',
    pretty_name: 'Destination',

  },
  {
    column_id: 'unloading_destination_hub_code',
    pretty_name: 'Unloading Destination',
  },
  {
    column_id: 'vehicle_number',
    pretty_name: 'Vehicle',
  },
  {
    column_id: 'ist_reference_number',
    pretty_name: 'Trip No.',
  },
  {
    column_id: 'consignment_count',
    pretty_name: 'No. of Consignments',
  },
  {
    column_id: 'weight',
    pretty_name: 'Weight(Kg)',
  },
  {
    column_id: 'actions',
    pretty_name: 'Actions',
  },
];
export const ColumnsToShowInSetupBagging = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'origin_hub_code',
    pretty_name: 'Origin Hub',
  },
  {
    column_id: 'destination_hub_code',
    pretty_name: 'Bag Destination Hub',
  },
  {
    column_id: 'consignment_destination_hub_code',
    pretty_name: 'Consignment Destination Hub',
  },
  {
    column_id: 'is_active',
    pretty_name: 'Active',
  },
  {
    column_id: 'master_last_updated_by',
    pretty_name: 'Last Updated By',
  },
  {
    column_id: 'master_last_updated_at',
    pretty_name: 'Last Updated At',
  },
  {
    column_id: 'created_by',
    pretty_name: 'Created By',
  },
  {
    column_id: 'created_at',
    pretty_name: 'Created At',
  },
];
export const ColumnsToShowInSetupBaggingSeries = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'start',
    pretty_name: 'Start',
  },
  {
    column_id: 'end',
    pretty_name: 'End',
  },
  {
    column_id: 'availableCount',
    pretty_name: 'Count',
  },
  {
    column_id: 'nextInSeries',
    pretty_name: 'Next In Series',
  },
  {
    column_id: 'createdAt',
    pretty_name: 'Date of Issue',
  },
  {
    column_id: 'actions',
    pretty_name: 'Actions',
    align: 'center',
  },
];
export const columnsToShowCreateBag = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'reference_number',
    pretty_name: 'CN#',
  },
  {
    column_id: 'origin_destination',
    pretty_name: 'Origin Destination',
  },
  {
    column_id: 'num_pieces',
    pretty_name: 'No. of Pieces',
  },
  {
    column_id: 'scan',
    pretty_name: 'Scan',
  },
];
export const columnsToShowCreateBagScanned = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'reference_number',
    pretty_name: 'CN#',
  },
  {
    column_id: 'origin_destination',
    pretty_name: 'Origin Destination',
  },
  {
    column_id: 'num_pieces',
    pretty_name: 'No. of Pieces',
  },
  {
    column_id: 'close',
    pretty_name: 'Close',
  },
];
export const columnsToShowDebagScanned = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'reference_number',
    pretty_name: 'CN#',
  },
  {
    column_id: 'origin_destination',
    pretty_name: 'Origin Destination',
  },
  {
    column_id: 'num_pieces',
    pretty_name: 'No. of Pieces',
  },
  {
    column_id: 'actions',
    pretty_name: 'Actions',
  },
];
export const thirdPartyColumnsToShowCommon = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'bag_reference_number',
    pretty_name: 'Bag Number',
  },
  {
    column_id: 'origin_destination',
    pretty_name: 'Origin Destination',
  },
  {
    column_id: 'total_consignments',
    pretty_name: 'No. of CNs',
  },
];
export const columnsToShowAssignBag = [
  ...thirdPartyColumnsToShowCommon,
  {
    column_id: 'scan',
    pretty_name: 'Scan',
  },
];

export const thirdPartyAssignColumnsToShowV2 = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
    width: 40,
  },
  {
    column_id: 'bag_reference_number',
    pretty_name: 'Bag#',
    width: 100,
  },
  {
    column_id: 'origin_destination',
    pretty_name: 'Origin Destination',
    width: 150,
  },
  {
    column_id: 'origin_address',
    pretty_name: 'Origin Address',
    width: 150,
  },
  {
    column_id: 'destination_address',
    pretty_name: 'Destination Address',
    width: 150,
  },
  {
    column_id: 'total_consignments',
    pretty_name: 'No. of CNs',
    width: 130,
  },
];

export const columnsToShowAssignBagV2 = [
  ...thirdPartyAssignColumnsToShowV2,
  {
    column_id: 'scan',
    pretty_name: 'Scan',
  },
];

export const columnsToShowAssignBagScanned = [
  ...thirdPartyColumnsToShowCommon,
  {
    column_id: 'close',
    pretty_name: 'Close',
  },
];
export const thirdPartyHandoverColumnsToShowCommon = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'bag_reference_number',
    pretty_name: 'Bag Number',
  },
  {
    column_id: 'courier_partner_reference_number',
    pretty_name: 'Carrier Manifest',
  },
  {
    column_id: 'total_bags',
    pretty_name: 'Total Bags in Carrier Manifest',
  },
];
export const availableForHandoverColumns = [
  ...thirdPartyHandoverColumnsToShowCommon,
  {
    column_id: 'scan',
    pretty_name: 'Scan',
  },
];

export const thirdPartyHandoverColumnsToShowCommonV2 = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
    width: 40,
  },
  {
    column_id: 'bag_reference_number',
    pretty_name: 'Bag#',
    width: 100,
  },
  {
    column_id: 'bag_type',
    pretty_name: 'Type',
    width: 100,
  },
  {
    column_id: 'origin_address',
    pretty_name: 'Origin Address',
    width: 150,
  },
  {
    column_id: 'destination_address',
    pretty_name: 'Destination Address',
    width: 150,
  },
  {
    column_id: 'courier_partner_reference_number',
    pretty_name: 'Carrier Manifest',
    width: 100,
  },
  {
    column_id: 'total_cns',
    pretty_name: 'Total CN',
    width: 100,
  },
];

export const availableForHandoverColumnsV2 = [
  ...thirdPartyHandoverColumnsToShowCommonV2,
  {
    column_id: 'scan',
    pretty_name: 'Scan',
    width: 50,
  },
];

export const scannedForHandoverColumns = [
  ...thirdPartyHandoverColumnsToShowCommon,
  {
    column_id: 'close',
    pretty_name: 'Close',
  },
];
export const infoColumnsToShow = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'cn_reference_number',
    pretty_name: 'Bag Number',
  },
];
export const handoverInfoColumnsToShow = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'bag_reference_number',
    pretty_name: 'Bag Number',
  },
  {
    column_id: 'is_scanned',
    pretty_name: 'Scanned(Y/N)',
  },
];
export const handoverDetailedInfoColumnsToShow = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'courier_partner_reference_number',
    pretty_name: 'Carrier Manifest No.',
  },
  {
    column_id: 'total_bags_in_awb',
    pretty_name: 'Total Bags in Carrier Manifest',
  },
  {
    column_id: 'total_scanned_bags',
    pretty_name: 'Total Scanned',
  },
];
export const columnsInEditBagModal = [
  {
    column_id: 'reference_number',
    pretty_name: 'Bag Number',
  },
  {
    column_id: 'courier_partner_reference_number',
    pretty_name: 'New Carrier Manifest No.',
  },
];
export const connectionColumns = {
  route_code: 'Route Code',
  connection_code: 'Connection Code',
  hub_code: 'Hub',
  arrival_time: 'Arrival Time',
  departure_time: 'Departure Time',
  mode: 'Mode',
  customer_code: 'Customer Code',
  is_active: 'Active',
  master_last_updated_by: 'Last Updated By',
  master_last_updated_at: 'Last Updated At',
  created_by: 'Created By',
  created_at: 'Created At',

};
export const getConnectionColumnPrettyNames = (key) => {
  return connectionColumns[key] ? connectionColumns[key] : key;
};
export const generateConnectionColumnsToshow = (columnConfig) => {
 return columnConfig.map((col) => {
  return ({column_id: col.key, pretty_name: getConnectionColumnPrettyNames(col.key)});
  });
};
export const columnsToShowLoadingCardScanned = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'reference_number',
    pretty_name: 'Waybills',
  },
  {
    column_id: 'origin_destination',
    pretty_name: 'Origin Destination',
  },
  {
    column_id: 'consignment_count',
    pretty_name: 'No. of Pieces',
  },
  {
    pretty_name: 'Unloading Destination',
     column_id: 'route_destination_hub_code',
  },
  {
    pretty_name: 'Actions',
    column_id: 'actions',
  },
];
export const columnsToShowLoadingCard = [
  {
    column_id: 'serial_number',
    pretty_name: 'S.N.',
  },
  {
    column_id: 'reference_number',
    pretty_name: 'Waybills',
  },
  {
    column_id: 'origin_destination',
    pretty_name: 'Origin Destination',
  },
  {
    column_id: 'consignment_count',
    pretty_name: 'No. of Pieces',
  },
  {
    column_id: 'last_main_event_time',
    pretty_name: 'Inscan Time',
    is_sortable: true,
  },
  {
    column_id: 'scan',
    pretty_name: 'Scan',
  },
];
export const getInboundActions = (masterData) => {
  const { t } = useTranslation();
 return [
  {
    id: 'hub_arrival',
    name: t('hub_arrival'),
    isAllowed: masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.hubArrival,
  },
  {
    id: 'gate_in',
    name: t('Gate In'),
    isAllowed: masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.gateIn,
  },
  {
    id: 'receive_ist',
    name: t('Trip Receive'),
  },
  {
    id: 'unloading',
    name: t('Unloading'),
    isAllowed: masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.unload,
  },
  {
    id: 'close_ist',
    name: t('Trip Close'),
  },
];
};

export const getDockActions = () => {
  const { t } = useTranslation();
  return [
    {
      id: 'assign_dock',
      name: t('Assign Dock'),
    },
    {
      id: 'dock_inscan',
      name: t('Dock Inscan'),
    },
    {
      id: 'dock_outscan',
      name: t('Dock Outscan'),
    },
  ];
}
export const getOutboundActions = (masterData) => {
  const { t } = useTranslation();
  return [
    {
      id: 'create_trip',
      name: t('Create Trip'),
      isAllowed: masterData.ops_dashboard_config?.parts_to_show?.ist_update,
    },
    {
      id: 'depart_ist',
      name: t('Trip Depart'),
    },
    {
      id: 'loading',
      name: t('Loading'),
      isAllowed: masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.load,
    },
    {
      id: 'gate_out',
      name: t('Gate Out'),
      isAllowed: masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.gateOut,
    },
  ];
};
export const getPtlActions = (masterData) => {
  const { t } = useTranslation();
  return [
    {
      id: 'create_ptl_trip',
      name: t('Create PTL Trip'),
      isAllowed: masterData.ops_dashboard_config?.parts_to_show?.ist_update &&
       masterData?.ist_feature_config?.show_ptl_trip_operation,
    },
  ];
};
export const getOtherActions = (masterData) => {
  const { t } = useTranslation();
  return [
    {
      id: 'apply_exception_code',
      name: t('Apply Exception Code'),
    },
    {
      id: 'offload',
      name: t('Offload'),
    },
    {
      id: 'print_manifest',
      name: t('Print Manifest'),
      isAllowed: masterData.ops_dashboard_config?.parts_to_show?.allow_label_print,
    },
    {
      id: 'add_trip_penalties',
      name: t('Add Trip Penalties'),
      isAllowed: masterData?.show_trip_penalties,
    },
    {
      id: 'delete_trip',
      name: t('Delete Trip'),
      isAllowed: masterData.ops_dashboard_config?.parts_to_show?.ist_update,
    },
    {
      id: 'capture_trip_bill',
      name: t('Capture Trip Bill'),
      isAllowed: masterData.allow_update_trip_bill,
    },
    {
      id: 'capture_trip_verification_details',
      name: t('Capture Trip Verification Details'),
      isAllowed: masterData.allow_trip_verification,
    },
  ];
};
export const getQuickActions = (masterData) => {
  const { t } = useTranslation();
  return [
    {
      id: 'inboundActions',
      name: t('Inbound'),
      subOptions: getInboundActions(masterData),
    },
    {
      id: 'outboundActions',
      name: t('Outbound'),
      subOptions: getOutboundActions(masterData),
    },
    {
      id: 'ptlActions',
      name: t('PTL'),
      subOptions: getPtlActions(masterData),
    },
    {
      id: 'dockActions',
      name: t('Dock Management'),
      subOptions: getDockActions(),
      isAllowed:
        masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.dockInScan ||
        masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.dockOutScan ||
        masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.dockAssign,
    },
    {
      id: 'otherActions',
      name: t('Other'),
      subOptions: getOtherActions(masterData),
    },
  ];
};
export const ColumnsToShowInSetupGates = [
  {
    column_id: 'hub_code',
    pretty_name: 'Hub Code',
  },
  {
    column_id: 'hub_name',
    pretty_name: 'Hub Name',
  },
  {
    column_id: 'gate_name',
    pretty_name: 'Gate Name',
  },
  {
    column_id: 'gate_code',
    pretty_name: 'Gate Code',
  },
  {
    column_id: 'created_by',
    pretty_name: 'Created By',
  },
  {
    column_id: 'created_at',
    pretty_name: 'Created At',
  },
];

export const ColumnsToShowInSetupDocks = [
  {
    column_id: 'hub_code',
    pretty_name: 'Hub Code',
  },
  {
    column_id: 'hub_name',
    pretty_name: 'Hub Name',
  },
  {
    column_id: 'dock_name',
    pretty_name: 'Dock Name',
  },
  {
    column_id: 'dock_code',
    pretty_name: 'Dock Code',
  },
  {
    column_id: 'created_at',
    pretty_name: 'Created At',
  },
  {
    column_id: 'created_by',
    pretty_name: 'Created By',
  },
];

export const bagExceptionsColumns = {
  code: 'Exception Code',
  name: 'Exception Name',
  active: 'Active Flag',
  efs_exception_code: 'EFS Exception Code',
  applicable_on: 'Applicable On',
  is_terminal: 'Is Terminal',
  created_by: 'Created By',
  created_at: 'Created At',
};

export const bagExceptionsDataMapping = {
  code: 'bag_exception_code',
  name: 'bag_exception_name',
  active: 'bag_exception_active',
  pre_requisite_exception_code: 'bag_pre_requisite_exception_code',
  pre_requisite_exception_duration: 'bag_pre_requisite_exception_duration',
  applicable_on: 'bag_exception_applicable_on',
  is_terminal: 'is_terminal_exception',
  created_by: 'created_by',
  created_at: 'created_at',
  efs_exception_code: 'efs_exception_code',
};

export const generateBagExceptionsColumnsToshow = (columnConfig) => {
  return columnConfig.map((col) => {
    return ({
      column_id: bagExceptionsDataMapping[col.key] ? bagExceptionsDataMapping[col.key]: col.key,
      pretty_name: bagExceptionsColumns[col.key] ? bagExceptionsColumns[col.key] : col.key,
    });
  });
};

export const ColumnsToShowInSetupBagExceptions = [
  {
    column_id: 'bag_exception_code',
    pretty_name: 'Exception Code',
  },
  {
    column_id: 'bag_exception_name',
    pretty_name: 'Exception Name',
  },
  {
    column_id: 'bag_exception_active',
    pretty_name: 'Active Flag',
  },
  {
    column_id: 'created_by',
    pretty_name: 'Created By',
  },
  {
    column_id: 'created_at',
    pretty_name: 'Created At',
  },
];

export const ColumnsToShowInEWBThresholdMaster = [
  {
    column_id: 'origin_state',
    pretty_name: 'Origin State',
  },
  {
    column_id: 'ewb_limit',
    pretty_name: 'EWB Threshold',
  },
];
